import { Component, OnInit, HostListener, ElementRef } from "@angular/core";
import { Router } from "@angular/router";

import { FormsModule } from "@angular/forms";
import { LanguageService } from "../services/language.service";
import { TranslateModule } from "@ngx-translate/core";
import { SecurityService } from "../services/security.service";
import { SessionStoreService } from "../services/session-store.service";
import { Portal } from "../services/portals/portal.model";
import { PortalsService } from "../services/portals/portals.service";
import { environment } from "../../environments/environment";

@Component({
    selector: "app-admin-session-switcher",
    templateUrl: "./admin-session-switcher.component.html",
    styleUrls: ["./admin-session-switcher.component.scss"],
    standalone: true,
    imports: [FormsModule, TranslateModule]
})
export class AdminSessionSwitcherComponent implements OnInit {
  isAdmin: boolean = false;
  readonly chatbotEnabled = environment.chatbotEnabled;
  sessions: Portal[] = [];
  activePortalId: string = "";
  currentLang: string = 'es';

  sessionSearch: string = '';
  isSessionDropdownOpen: boolean = false;
  isMobileOptionsOpen: boolean = false;

  get activeSession(): Portal | null {
    return this.sessions.find(s => s.id.toString() === this.activePortalId) || null;
  }

  get filteredSessions(): Portal[] {
    const q = this.sessionSearch.trim().toLowerCase();
    if (!q) return this.sessions;
    return this.sessions.filter(s => s.name.toLowerCase().includes(q));
  }

  get sessionDisplayValue(): string {
    if (this.isSessionDropdownOpen) return this.sessionSearch;
    return this.activeSession ? this.activeSession.name : '';
  }

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private elRef: ElementRef,
    private securityService: SecurityService,
    private sessionStore: SessionStoreService,
    private portalsService: PortalsService
  ) {}

  ngOnInit(): void {
    this.isAdmin = this.securityService.isSuperAdmin();

    if (this.isAdmin) {
      this.portalsService.getPortals$().subscribe((portals) => {
        this.sessions = portals;
      });
      this.activePortalId = this.sessionStore.getActivePortalId();
    }

    this.currentLang = this.languageService.getCurrentLanguage();
  }

  openSessionDropdown(): void {
    this.isSessionDropdownOpen = true;
    this.sessionSearch = '';
    this.portalsService.getPortals$(true).subscribe((portals) => {
      this.sessions = portals;
    });
  }

  selectSession(session: Portal): void {
    this.sessionSearch = '';
    this.isSessionDropdownOpen = false;
    this.changeSession(session.id.toString());
  }

  onSessionInputChange(value: string): void {
    this.sessionSearch = value;
    if (!this.isSessionDropdownOpen) this.isSessionDropdownOpen = true;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isSessionDropdownOpen = false;
      this.sessionSearch = '';
      this.isMobileOptionsOpen = false;
    }
  }

  toggleMobileOptions(): void {
    this.isMobileOptionsOpen = !this.isMobileOptionsOpen;
  }

  changeSession(selectedId: string): void {
    const selectedSession = this.sessions.find(s => s.id.toString() === selectedId);
    if (!selectedSession) return;

    this.sessionStore.setSesion(selectedSession.sesion);
    this.sessionStore.setActivePortalId(selectedId);
    this.activePortalId = selectedId;

    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(["/my-portals"]);
    });
  }

  changeLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
    this.currentLang = lang;
    console.log('🌐 [Language Switcher] Idioma cambiado a:', lang);
  }

  goToAssistant(): void {
    this.router.navigate(['/asistente']);
  }
}
